import { Close, Verified } from "@mui/icons-material";
import { Dialog, DialogProps } from "@mui/material";
import { SURVEY_MATCH_POPUP } from "utils/constants";

import { SurveyMatchPopupProps } from "./interface";
import {
  DialogCloseButton,
  DialogContentWrapper,
  HeadingText,
  IconBadge,
  MessageText,
  PointsText,
  StartButton,
  StartButtonWrapper,
  TimeText,
} from "./styled.components";

const SurveyMatchPopup = (props: SurveyMatchPopupProps) => {
  const { show, dismiss, survey, onStartSurveyClicked } = props;

  const handleClose: DialogProps["onClose"] = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    dismiss();
  };

  if (!survey) {
    return null;
  }

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogContentWrapper>
        <DialogCloseButton
          onClick={dismiss}
          aria-label={SURVEY_MATCH_POPUP.CLOSE_ICON_LABEL}
        >
          <Close fontSize="small" />
        </DialogCloseButton>

        <IconBadge>
          <Verified />
        </IconBadge>

        <HeadingText>{SURVEY_MATCH_POPUP.HEADING}</HeadingText>
        <MessageText>
          You can earn <PointsText>{survey.points} points</PointsText> from
          taking this survey
        </MessageText>
        {survey.timeToComplete && (
          <MessageText>
            It will only take you roughly{" "}
            <TimeText>{survey.timeToComplete}</TimeText>
          </MessageText>
        )}

        <StartButtonWrapper>
          <StartButton
            type="button"
            variant="contained"
            disableElevation
            onClick={() => onStartSurveyClicked(survey)}
          >
            {SURVEY_MATCH_POPUP.START_BUTTON_TEXT}
          </StartButton>
        </StartButtonWrapper>
      </DialogContentWrapper>
    </Dialog>
  );
};

export default SurveyMatchPopup;
